// extracted by mini-css-extract-plugin
module.exports = {"Policy":"Policy_Policy__6CLo_","Title":"Policy_Title__1JHN8","SectionTitle":"Policy_SectionTitle__2sEDm"};